export default __webpack_public_path__ + "static/811-logo-f738f98c8f93a7b04dd9dbddacaa0007.png";